let isDebounced: NodeJS.Timeout | null = null;
export const debounceFunction = (functionToCall: () => void, delay: number) => {
  if (isDebounced) clearTimeout(isDebounced);
  isDebounced = setTimeout(() => functionToCall(), delay);
};
